export function trackEvent(name, data) {
  try {
    Promise.resolve(window.umami?.track(name, data)).catch(() => {});
  } catch {
    // Analytics must not interrupt the game.
  }
}
